import { createSelector } from 'reselect';
const selectPreviewState = state => state.preview;
export const selectIsPreview = createSelector(selectPreviewState, state => state.isPreview);
export const selectPreviewJwt = createSelector(selectPreviewState, state => state.previewJwt);